import Vue from 'vue';
import '@/plugins/axios';
import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import { VueMaskDirective } from 'v-mask';
import router from './router';
import store from './store';

Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false;

// handle page reloads
const app: Vue = new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  render: h => h(App),
});
